<template>
  <b-card title="مدیریت اسلایدر">
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  variant="primary"
                  class="mb-1 mr-auto ml-1"
                  :to="{ name: 'sliderAdd'}"
              >
                جدید
              </b-button>

              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(StartDate)="data">
            {{ data.value | date }}
          </template>

          <template #cell(EndDate)="data">
            {{ data.value | date }}
          </template>

          <template #cell(ViewType)="data">
            {{ enums('blogBannersViewType','value',data.value,'text') }}
          </template>

          <template #cell(PlaceType)="data">
            {{ enums('placeType','value',data.value,'text') }}
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="enums('IsActive', 'value', data.value, 'badge')"
            >
              {{ enums('IsActive', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-link :to="{ name: 'sliderEdit', params: { id: data.item.Id }}">
                <feather-icon
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>
          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>

    <b-modal
        v-model="showRemoveModal"
        title="حذف"
        size="sm"
        centered
        hide-footer
        modal-class="modal-danger"
        :no-close-on-backdrop="true"
    >
      <b-overlay
          :show="loadingRemove"
          rounded="sm"
      >
        <span>آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟</span>
        <b-col class="mt-3 text-center">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              @click="confirmRemove"
          >
            تایید
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="showRemoveModal = false"
          >
            انصراف
          </b-button>
        </b-col>
      </b-overlay>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Slider',
  data() {
    return {
      totalRows: 1000 * 1000,
      filterOptions: {
        Page: 1,
        Title: null,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Description',
          label: 'توضیحات',
        },
        {
          key: 'ViewType',
          label: 'نوع نمایش',
        },
        {
          key: 'PlaceType',
          label: 'محل نمایش',
        },
        {
          key: 'StartDate',
          label: 'از تاریخ',
        },
        {
          key: 'EndDate',
          label: 'تا تاریخ',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },

      ],
      items: [],
      loading: false,
      id: null,
      loadingRemove: false,
      showRemoveModal: false,
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.slider.getList, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.id = id
      this.showRemoveModal = true
    },
    confirmRemove() {
      this.loadingRemove = true
      this.$http.post(
          this.$api.slider.remove, { Id: this.id },
      )
          .then(() => {
            this.showRemoveModal = false
            this.loadingRemove = false
            this.update()
          }).catch(() => {
        this.loadingRemove = false
        this.showRemoveModal = false
      })
    },
  },
}
</script>

<style scoped>
.notification-status{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.item-status-title {
  margin-bottom: 0px;
  color: #6e6b7b;
}
.font-weight-700{
  font-weight: 600;
  color: #5e5873;
}
</style>
